"use client";

import * as React from "react";

import { Popover, PopoverTrigger } from "@unreserved/ui/components/popover";
import { cn } from "@unreserved/utils";

import { NotificationIcon } from "@/app/_components/icons/header/notification";

import { NotificationsPopoverContent } from "./notifications-popover-content";

export function NotificationTriggerContent({
  count,
  className,
}: {
  count: number;
  className?: string;
}) {
  // count=18;
  return (
    <>
      <div className={cn("relative flex size-5 items-center justify-center md:size-6", className)}>
        <NotificationIcon className="h-full w-full" />
      </div>
      {count > 0 && (
        <span
          className={cn(
            "bg-error-600 absolute top-1.5 left-[calc(50%+8px)] flex size-3.5 -translate-x-1/2 items-center justify-center rounded-full text-[8px] leading-tight font-normal text-white sm:top-2 sm:size-4 md:top-[7px] md:left-[calc(50%+10px)] md:text-[9px]",
            count > 99 ? "top-1 size-4 sm:size-5 md:top-[5px]" : "",
          )}
          aria-label={`${count} unread notifications`}>
          {count > 99 ? "99+" : count}
        </span>
      )}
    </>
  );
}

export function NotificationsMenuDesktop({ count = 0 }: { count?: number }) {
  const [open, setOpen] = React.useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen} modal={false}>
      <PopoverTrigger asChild>
        <button
          className={cn(
            "bg-background-50 relative flex size-10 cursor-pointer items-center justify-center rounded-full p-2 md:size-12 md:p-2",
          )}
          aria-label="Notifications">
          <NotificationTriggerContent count={count} />
        </button>
      </PopoverTrigger>
      {open && <NotificationsPopoverContent onClose={() => setOpen(false)} />}
    </Popover>
  );
}
